export const SAVING_STATUSES = new Set(["claiming", "saving"]);

// Matches the server claim lease. A missing record before this is the save
// still running, not a failure. Do not unbatch from either result.
export const BATCH_SAVE_GIVE_UP_MS = 15 * 60 * 1000;

/**
 * What to show while a batch save is in flight.
 * "saving" — keep waiting. "ready" — the batch record is past claiming/saving.
 * "unconfirmed" — the record is still missing after the give-up window.
 * Say the save could not be confirmed. Do not say it was not saved, and do not unbatch.
 */
export function batchSavePhase({
  loading = false,
  exists = false,
  status = "",
  serverStatus = "",
  startedAt = 0,
  now = 0,
} = {}) {
  // The browser listener can miss the batch document. The server read is the
  // one the page header already uses. A finished server status ends the wait.
  if (serverStatus && !SAVING_STATUSES.has(serverStatus)) return "ready";
  if (loading) return "saving";
  if (exists && SAVING_STATUSES.has(status)) return "saving";
  if (exists) return "ready";
  if (now - startedAt < BATCH_SAVE_GIVE_UP_MS) return "saving";
  return "unconfirmed";
}
